const SHIFT_DEFAULT = {
  id: null,
  active: true,
  days: [1,2,3,4,5],
  time_start: '00:00',
  time_end: '00:00',
  dates_active: false,
  date_start: null,
  date_end: null,
  channels: {"email":[],"sms":[],"tts":[]},
  order: 1
}

export { SHIFT_DEFAULT }